import React from 'react';

import MhcTip from './c2c/mhcTip/MhcTip';
import V3_1Tip from './c2c/v3.1Tip/V3_1Tip';
import DeclareTip from './declareTip/DeclareTip';
import HpdTip from './hpdTip/HpdTip';
import MfrInvTip from './mfrInvTip/MfrInvTip';
import EpProgramTip from '../epProgramTip/EpProgramTip';
import CmfImpactAreasTip from '../cmfImpactAreasTip/cmfImpactAreasTip';
import DtImpactAreasTip from '../dtImpactAreasTip/dtImpactAreasTip';
import Ec3Tip from '../ec3Tip/EC3Tip';
import Ec3TipListing from '../ec3TipListing/EC3TipListing';
import LPCTip from './LCPTip/LPCTip';
import LowEmittingTip from '../lowEmittingTip/lowEmittingTip';

const getTipByMaterialProgram = (materialProgram: string, dataInput: Array<any>, productsTab = false) => {
    const regex = new RegExp(/(HPD)\sv\d(?:\.\d)*|C2C\s(V3\.1|MHC)|(Declare)|(LPC)|(EpProgram)|(Ec3)|(ListingEc3)|(cmfImpactAreas)|(dtImpactAreas)|(Mfr\sInv)|(LowEmitting)/gm);
    const groups = regex.exec(materialProgram);
    const program = groups?.filter((element) => {
        return element !== undefined;
    })[1];
    switch (program) {
        case 'HPD':
            return <HpdTip />;
        case 'C2C V3.1':
            return <V3_1Tip />;
        case 'C2C MHC':
            return <MhcTip />;
        case 'MHC':
            return <MhcTip />;
        case 'Declare':
            return <DeclareTip />;
        case 'LPC':
            return <LPCTip />
        case 'EpProgram':
            return <EpProgramTip productsTab={productsTab} />;
        case 'cmfImpactAreas':
            return <CmfImpactAreasTip cmfImpactAreas={dataInput} />;
        case 'dtImpactAreas':
            return <DtImpactAreasTip dtImpactAreas={dataInput} />;
        case 'Mfr Inv':
            return <MfrInvTip />;
        case 'V3.1':
            return <V3_1Tip />;
        case 'Ec3':
            return <Ec3Tip />;
        case 'ListingEc3':
            return <Ec3TipListing />;
        case 'LowEmitting':
            return <LowEmittingTip />;
    }

    return <></>;
};

interface Props {
    materialProgram: string;
    dataInput: Array<any>;
    productsTab: boolean;
}

const ProgramTipsController: React.FC<Props> = ({ materialProgram, productsTab, dataInput }) => {
    return <>{getTipByMaterialProgram(materialProgram, dataInput, productsTab)}</>;
};

export default ProgramTipsController;
